module.exports = __webpack_public_path__ + "img/Battery.88269f42.svg";